import { ChangeDetectorRef ,ViewRef,Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'
import { MapDialog } from './dialog/map-dialog.component'
import { JSONRpcResponse } from '../../../../Interfaces/JSONRpcResponse'
import { DialogService, StateService,DossierService,
NoteService
 } from '../../../../services'


import {
	Observable,
	BehaviorSubject,	
} from "rxjs";

const KEY = 'map'

@Component({
  selector: 'atyl-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
@Stringable({
  path: 'views/partials/content/actions/map-actions-dialog',
  key: KEY,
})
export class MapComponent implements OnInit {

  @Input() loading:BehaviorSubject<any>=new BehaviorSubject<any>(null);
  
  @StringableValues(KEY) strings: any
  
  @Input() dossier: any;
  @Input() adresse: any;


  constructor(
    private changeDetector: ChangeDetectorRef,
    private stateService: StateService,
    private dialogService: DialogService,
    private dossierService: DossierService,
    private changeDetectorRef: ChangeDetectorRef,
     private noteService: NoteService
  ) { }

  ngOnInit() {
	  
	 
    
  
  
   
	   	
   }
  
   detectChanges() {
        setTimeout(() => {
            if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
                this.changeDetectorRef.detectChanges()
            }
        })
    }
    
   	map(event:any) {
	    const dialogRef = this.dialogService.open(MapDialog, {
            data: {
               
                dossier: this.dossier,
               adresse: this.adresse
            },
            draggable: false,
            resizable: false,
            height: '90vh',
			width: "90vw",
        })
        
         dialogRef.afterClosed().subscribe(result => {
            
        });
	   
    }
   
  

}
